import { useEffect, useState } from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import SweetAlertService from "../../../services/SweetAlertService";
import ContentService from "../../../pages/admin/Shared/Services/ContentService";

export const HomePage = (props:any) => {
    const [show, setShow] = useState(false);

    const [heading, setHeading] = useState("");
    const [description, setDescription] = useState("");

    useEffect(() => {
        getModalPopUpContent();
    }, []);

    const getModalPopUpContent = () => {
        ContentService.getModalPopUpContent().then((response: any) => {
            setDescription(response.data.description);
            setHeading(response.data.heading);
            setShow(true);
        }).catch(() => {
            SweetAlertService.error("Error", `Something went wrong while getting content`);
        })
    }

    const handleClose = () => setShow(false);

    return (
        <>
            <div className="hero-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <div className="hero-banner__inner">
                                <h1 className="hero-banner__title">GP Diary</h1>
                                <h2 className="hometext">Built for doctors, by doctors</h2>
                                <div className="hero-banner-meta">
                                    <p className="loggedin">
                                        Track your worked time and compare it to your contract, with this BMA tool for
                                        GPs.
                                    </p>
                                    <p className="loggedin">
                                        Record your daily work activities, then create reports to review your
                                        work patterns.
                                    </p>
                                </div>
                            </div>
                            <br />
                            <div className="float start">
                                <button className="btn btn-primary" onClick={() => props.login()}>
                                    Start Now
                                </button>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <figure className="hero-banner__rotachecker">
                                <img src={require('../../../assets/images/home-page-Image.png')} alt="home-page-Image" />
                            </figure>
                        </div>
                    </div>
                </div>
            </div>

            <Modal size="lg" show={show}>
                <Modal.Header closeButton onClick={handleClose}>
                    <Modal.Title><h4>{heading}</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col>
                                <span>{description}</span>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}